function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M25.323 12.636a1.3 1.3 0 00-1.839 0l-4.526 4.525-4.525-4.525a1.3 1.3 0 00-1.838 1.838L17.12 19l-4.526 4.525a1.3 1.3 0 001.839 1.839l4.526-4.526 4.525 4.526a1.3 1.3 0 001.838-1.839L20.797 19l4.526-4.526a1.3 1.3 0 000-1.838z",
  fill: "#949494"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 16,
  stroke: "#949494",
  strokeWidth: 2
});

function SvgCircleClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI1LjMyMjUgMTIuNjM1OUMyNC44MTQ4IDEyLjEyODMgMjMuOTkxNyAxMi4xMjgzIDIzLjQ4NCAxMi42MzU5TDE4Ljk1ODUgMTcuMTYxNEwxNC40MzMgMTIuNjM1OUMxMy45MjUzIDEyLjEyODMgMTMuMTAyMiAxMi4xMjgzIDEyLjU5NDUgMTIuNjM1OUMxMi4wODY5IDEzLjE0MzYgMTIuMDg2OSAxMy45NjY3IDEyLjU5NDUgMTQuNDc0NEwxNy4xMiAxOC45OTk5TDEyLjU5NDUgMjMuNTI1NEMxMi4wODY5IDI0LjAzMzEgMTIuMDg2OSAyNC44NTYyIDEyLjU5NDUgMjUuMzYzOUMxMy4xMDIyIDI1Ljg3MTUgMTMuOTI1MyAyNS44NzE1IDE0LjQzMyAyNS4zNjM5TDE4Ljk1ODUgMjAuODM4NEwyMy40ODQgMjUuMzYzOUMyMy45OTE3IDI1Ljg3MTUgMjQuODE0OCAyNS44NzE1IDI1LjMyMjUgMjUuMzYzOUMyNS44MzAxIDI0Ljg1NjIgMjUuODMwMSAyNC4wMzMxIDI1LjMyMjUgMjMuNTI1NEwyMC43OTcgMTguOTk5OUwyNS4zMjI1IDE0LjQ3NDRDMjUuODMwMSAxMy45NjY3IDI1LjgzMDEgMTMuMTQzNiAyNS4zMjI1IDEyLjYzNTlaIiBmaWxsPSIjOTQ5NDk0Ii8+CjxjaXJjbGUgY3g9IjE5IiBjeT0iMTkiIHI9IjE2IiBzdHJva2U9IiM5NDk0OTQiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";
export { SvgCircleClose as ReactComponent };